import React from 'react'
import Ledger from './Ledger'

const index = () => {
  return <Ledger />
}

export default index